// extracted by mini-css-extract-plugin
module.exports = {"root":"_913bbc","logo":"_470b61","heading":"_66a326"};